import {init} from '@amplitude/analytics-browser';
import {isNamespaceStaging} from './env';
import {isCsr} from './is-csr';

/**
 * Amplitude Analytics를 초기화합니다.
 * @see https://amplitude.com/docs/sdks/analytics/browser/browser-sdk-2
 */
export const initAmplitudeAnalytics = () => {
  if (!isCsr() || typeof process.env.GATSBY_NAMESPACE_ENV !== 'string') {
    return;
  }
  init(AMPLITUDE_API_KEY, undefined, {
    autocapture: {
      pageViews: true,
    },
    serverUrl: AMPLITUDE_ANALYTICS_PROXY_URL,
    attribution: {
      resetSessionOnNewCampaign: true,
    },
  });
};

/**
 * AMPLITUDE_API_KEY 는 브라우저에 노출되어도 안전합니다.
 * @see https://github.com/amplitude/Amplitude-Javascript/issues/100
 */
const AMPLITUDE_API_KEY = isNamespaceStaging()
  ? 'c561f1d3bba529cfca4986bf8f09febf'
  : '70165f5cda5812a2a498cf94f4282e58';

/**
 * Amplitude Analytics Proxy Server URL
 *
 * @description
 * 광고차단 애플리케이션(AdGuard, AdBlock 등)이 Amplitude의 직접 도메인 요청을 차단하여
 * 이벤트 전송 및 실험변수 조회가 실패하는 문제를 해결하기 위해 자체 프록시 서버를 경유합니다.
 *
 * @see https://docs.google.com/document/d/1bEl3yQNEVrqLRGOdcaRN9yoqfAHuU-tcDriu6QshJbs/edit?tab=t.0#bookmark=id.loiuesckvum7
 * @see https://amplitude.com/docs/analytics/domain-proxy
 */
const AMPLITUDE_ANALYTICS_PROXY_URL = isNamespaceStaging()
  ? 'https://analytics-proxy.staging.banksalad.com/2/httpapi'
  : 'https://analytics-proxy.banksalad.com/2/httpapi';
